import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { LiabilityService } from '../services/liability.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LiabilityVerificationResolver implements Resolve<boolean> {
  constructor(private liabilityService: LiabilityService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.liabilityService.isVerified(route.params.id);
  }
}
